/**
 * SettingsPage Component
 * Application settings including expense email forwarding configuration.
 * Route: /settings
 */

import { EmailIngestSettings } from '../components/expenses/EmailIngestSettings';
import { PageHeader } from '../components/layout/index';
import { AppearanceSettings } from '../components/settings/AppearanceSettings';
import { SettingsLayout } from '../components/settings/SettingsLayout';

export function SettingsPage() {
  return (
    <SettingsLayout>
      <div data-testid="settings-page">
        <div className="px-[var(--page-padding-x)]">
          <PageHeader
            title="Settings"
            subtitle="Manage your account and application preferences."
          />
        </div>

        <div className="px-[var(--page-padding-x)] flex flex-col gap-6">
          <AppearanceSettings />
          <section aria-labelledby="expense-email-heading">
            <h2
              id="expense-email-heading"
              className="mb-3 text-lg font-semibold text-foreground"
            >
              Expense Email
            </h2>
            <EmailIngestSettings />
          </section>
        </div>
      </div>
    </SettingsLayout>
  );
}

export default SettingsPage;
